import { render, staticRenderFns } from "./list.vue?vue&type=template&id=05d3cf92&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=05d3cf92&scoped=true&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=05d3cf92&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3cf92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d3cf92')) {
      api.createRecord('05d3cf92', component.options)
    } else {
      api.reload('05d3cf92', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=05d3cf92&scoped=true", function () {
      api.rerender('05d3cf92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/list.vue"
export default component.exports